import { useEffect, useState } from "react";
import type { SSEEvent } from "../hooks/use-event-stream";

export const DISMISS_MS = 5000;
export const MAX_VISIBLE = 3;

export function getVisibleEvents(
	events: SSEEvent[],
	dismissedIds: Set<string>,
): SSEEvent[] {
	return events.filter((e) => !dismissedIds.has(e.id)).slice(-MAX_VISIBLE);
}

export function NotificationToast({ events }: { events: SSEEvent[] }) {
	const [dismissedIds, setDismissedIds] = useState<Set<string>>(new Set());

	const visible = getVisibleEvents(events, dismissedIds);

	useEffect(() => {
		if (visible.length === 0) return;

		const timers = visible.map((e) =>
			setTimeout(() => {
				setDismissedIds((prev) => new Set(prev).add(e.id));
			}, DISMISS_MS),
		);

		return () => {
			for (const t of timers) clearTimeout(t);
		};
	}, [visible]);

	if (visible.length === 0) return null;

	return (
		<div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
			{visible.map((event) => (
				<div
					key={event.id}
					data-testid="notification-toast"
					className="bg-white border border-gray-200 shadow-lg rounded-lg px-4 py-3 text-sm text-gray-900 max-w-sm"
				>
					<span className="font-medium">{event.type}</span>
					{typeof event.payload === "object" &&
					event.payload !== null &&
					"name" in event.payload ? (
						<span className="text-gray-600 ml-1">
							{String((event.payload as Record<string, unknown>).name)}
						</span>
					) : null}
				</div>
			))}
		</div>
	);
}
